import { PeriodicidadeCorrecao } from 'common/genericTypes';

// Mapeamento de string para número (API -> frontend)
export const periodicidadeStringParaNumero = (periodicidade: string | null | undefined): number | undefined => {
  if (!periodicidade) return undefined;
  
  switch (periodicidade.toUpperCase()) {
    case PeriodicidadeCorrecao.Diario:
      return 0;
    case PeriodicidadeCorrecao.Mensal:
      return 1;
    case PeriodicidadeCorrecao.Anual:
      return 2;
    default:
      return undefined;
  }
};
